// extracted by mini-css-extract-plugin
export default {"wrapper":"mq6H_","banner":"fXCtf","image":"IUZuN","text":"gFX2w","link":"cch6g","title":"bQxrI","subtitle":"Z9skG"};